module.exports = __webpack_public_path__ + "static/img/005.8c5c9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/005.png
// module id = L7VK
// module chunks = 1